import { render, staticRenderFns } from "./ExtrasMessage.vue?vue&type=template&id=8a38f3b4&"
import script from "./ExtrasMessage.vue?vue&type=script&lang=js&"
export * from "./ExtrasMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports